let scrollListener = null;
let $scrollRoot = null;
let isFullPageScroll = false;

export function initCategoryScrollSync({ rootContainer, $ }) {
  // isFullPageScroll = $('#app').length > 0;
  // $scrollRoot = isFullPageScroll ? $(document.scrollingElement || 'html') : $(rootContainer);
  $scrollRoot = rootContainer.find('.booking-steps-holder');
  isFullPageScroll = false;
  const $list = $('.step-multiple-categories-list', $scrollRoot);
  const $items = $('li a', $list);
  const $titles = $('.step-category-title', $scrollRoot);
  const firstChildTop = $titles.length > 0 ? $titles.first().position().top : 0;

  // Activate first category item
  $items.first().addClass('active');

  // Click on a category scrolls to service group
  $list.on('click', 'a', function (e) {
    e.preventDefault();
    const targetId = $(this).attr('href').substring(1);
    const $target = $scrollRoot.find('#' + targetId);  // scoped find

    console.log("cat click", $scrollRoot, $scrollRoot.scrollTop() + $target.position().top - firstChildTop, $scrollRoot.scrollTop(), $target.position().top);

    if ($target.length) {
      $scrollRoot.animate({
        scrollTop: $target.position().top - firstChildTop
      }, 300, 'linear');
    }
  });

  // Arrows
  const $prev = $('.step-categories-slider-prev', $scrollRoot);
  const $next = $('.step-categories-slider-next', $scrollRoot);

  const animateSlide = (dist) => {
    $list.animate({ scrollLeft: $list.scrollLeft() + dist }, 200);
  };

  $next.on('click', () => animateSlide(200));
  $prev.on('click', () => animateSlide(-200));

  // Hide arrows if no scroll overflow
  setTimeout(() => {
    if ($list[0]?.scrollWidth <= $list[0]?.clientWidth) {
      $prev.hide();
      $next.hide();
    }
  }, 0);

  // Active tab follows scroll
  const slideToItem = (item) => {
    const listOffset = $list.offset().left;
    const itemOffset = $(item).offset().left;
    const currentScroll = $list.scrollLeft();
    $list.animate({ scrollLeft: currentScroll + itemOffset - listOffset }, 0);
  };

  const updateActiveCategory = () => {
    const wrapper = $('#booking-step-services');
    const wrapperTop = wrapper.position().top;
    const scrollTop = $scrollRoot.scrollTop();
    const containerHeight = $scrollRoot[0].scrollHeight - $scrollRoot[0].clientHeight;
    let last = null;

    // console.log('scrollTop', scrollTop, containerHeight, $scrollRoot[0].scrollHeight, $scrollRoot.outerHeight(), $scrollRoot.innerHeight());

    $titles.each(function () {
      const offset = $(this).position().top; // relative to $scrollRoot
      // console.log('offset', offset, offset - wrapperTop, scrollTop, $(this).text());
      if (offset - wrapperTop <= scrollTop + 81) last = this;
    });

    if (scrollTop >= containerHeight - 20) {
      last = $titles.last()[0];
    }
    if (!last) last = $titles.first()[0];

    if (last) {
      const id = last.id;
      const $item = $items.filter(`[href="#${id}"]`);
      $items.removeClass('active');
      $item.addClass('active');
      slideToItem($item);
    }
  };

  const debounce = (fn, delay = 100) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      console.log("Timer", timer);
      timer = setTimeout(() => fn(...args), delay);
    };
  };

  scrollListener = debounce(updateActiveCategory);
  if (isFullPageScroll) {
    $(window).on('scroll', scrollListener);
  } else {
    $scrollRoot.on('scroll', scrollListener);
  }
}

export function destroyCategoryScrollSync() {
  if (scrollListener && $scrollRoot) {
    if (isFullPageScroll) {
      $(window).off('scroll', scrollListener);
    } else {
      $scrollRoot.off('scroll', scrollListener);
    }
    scrollListener = null;
    $scrollRoot = null;
  }
}
